module.exports = __webpack_public_path__ + "static/media/saving-ico-white.343519c0.svg";